import { H6 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import { ComponentProps, ReactElement, ReactNode } from "react";
import { ListElement, ProfilePicture } from "../../../../components";
import {
  formatOrderListDate,
  getOrderDeliveryLabel,
  getOrderListUrl,
} from "./orderListElementHelpers";
import { OrderListOrder } from "./orderListElementTypes";

type OrderListElementLayoutProps = {
  order: OrderListOrder;
  selected: boolean;
  businessName: string;
  logoUrl: string | null;
  badges: ReactNode;
  date: ReactNode;
  businessNameAccessory?: ReactNode;
  icon?: ComponentProps<typeof ListElement>["icon"];
  onClick?: () => void;
  showFulfillment: boolean;
};

export const OrderListElementLayout = ({
  order,
  selected,
  businessName,
  logoUrl,
  badges,
  date,
  businessNameAccessory,
  icon,
  onClick,
  showFulfillment,
}: OrderListElementLayoutProps): ReactElement => {
  return (
    <ListElement
      to={getOrderListUrl(order)}
      selected={selected}
      icon={icon}
      onClick={onClick}
      navigation="child"
    >
      <ProfilePicture name={businessName} logoUrl={logoUrl} />
      <div className="w-full space-y-2">
        <div className="flex flex-col">
          <H6 className="flex justify-between text-sm">
            <span>
              Order #{order.id}
              {order.customInvoiceNumber && ` (${order.customInvoiceNumber})`}
            </span>
            {showFulfillment && (
              <span className="text-xs font-medium text-zinc-800">
                {getOrderDeliveryLabel(order)}
              </span>
            )}
          </H6>
          <div className="flex gap-1">
            <span className="title">{businessName}</span>
            {businessNameAccessory}
          </div>
        </div>
        <div className="flex flex-wrap gap-2">{badges}</div>
        <div className="fs-14 text-secondary">
          <div className="flex items-center justify-between">
            <span className="text-xs">
              <span className="font-semibold">
                {formatCurrency(order.price, order.currency)}
              </span>{" "}
              - Placed on: {formatOrderListDate(order.createdAt)}
            </span>
            {date}
          </div>
        </div>
      </div>
    </ListElement>
  );
};
